import { generateColorShades, theme } from '../theme/theme';

export const COLORS = {
  primary: '#3A27B4',
};

export const pulseCheckTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    primary: generateColorShades(COLORS.primary),
    accentColor: '#FF8E79',
  },
};

export type PulseCheckTheme = typeof pulseCheckTheme;
